import { render } from "./AddRelatedRelationshipModal.vue?vue&type=template&id=7265ba96&ts=true"
import script from "./AddRelatedRelationshipModal.vue?vue&type=script&lang=ts"
export * from "./AddRelatedRelationshipModal.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/saas-merchant-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__